import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { _ } from '../../functions/translator.js';
import { HiOutlineDocumentReport } from "react-icons/hi";
import { CircularProgress } from '@material-ui/core'

function ExportObservationsPdfButton(props){
    const { selectedCardsGroups, projectData} = useSelector(state => ({
        selectedCardsGroups: state.selectedCardsGroups,
        projectData : state.projectData,
    }))
    const [showLoading, setShowLoading] = useState(false);

    const buttonRef = useRef(null);

    const handleSubmit = async () => {
        setShowLoading(true)
        try {
            let url = window.location.origin + '/protocol-observations-pdf?project_id=' + window.project_id + '&cards_group_ids='
            let haveProtocolId = false
            selectedCardsGroups.forEach((cardsGroupId) => {
                if (projectData.cards_groups[cardsGroupId].attributes.protocol_id){
                    haveProtocolId = true
                    return
                }
            })
            if (!haveProtocolId) {
                url = window.location.origin + '/reception-images-report?project_id=' + window.project_id + '&cards_group_ids='
            }
            selectedCardsGroups.forEach((cardsGroupId, index) => {
                url += cardsGroupId.toString()
                if (index < selectedCardsGroups.length - 1) {
                    url += ','
                }
            });
            window.open(url)

        } catch (error) {
            console.error('Error:', error);
        } finally {
            setShowLoading(false)
        }
    };

    return(
        <div className="popup-menu-button card-color" ref={buttonRef} >
            <div className='w-100' onClick={handleSubmit}>
                <div className='w-100 d-inline-flex d-flex flex-row align-items-center'>
                    <div style={{width:'25px', height:'100%', position:'relative', left:'10px', marginRight:'2.5px', marginLeft:'2.5px'}}>
                        <HiOutlineDocumentReport size={30}/>
                    </div>
                    <div className='w-100 m-0 mt-1 d-flex justify-content-start align-items-center flex-column'>
                        <p className='m-0'>{ _('Exportar Informe con') }</p>
                        <p className='m-0'>{ _('Imágenes') }</p>
                    </div>
                </div>
                {showLoading && 
                    <div style={{ position: 'absolute', top: '20%', right: '-25px' }}>
                        <CircularProgress style={{ width:'20px', height:'20px' }} />
                    </div>
                }
            </div>
        </div>
    )
}

export default ExportObservationsPdfButton